import React, { Fragment } from 'react';
import { Link } from '@zapier/design-system';

const views = {
  ['DEFAULT']: () => ({
    bodyText: (
      <Fragment>
        Upgrade to email our world class Support team and we’ll help get you up
        and running! Or, get{' '}
        <Link href="/community" target="_blank">
          support from our Community
        </Link>
        , for free.
      </Fragment>
    ),
    type: 'DEFAULT',
  }),
};

export const getActiveView = () => views.DEFAULT();
